import { render, staticRenderFns } from "./AttachmentStorage.vue?vue&type=template&id=21dc3818&scoped=true"
import script from "./AttachmentStorage.vue?vue&type=script&lang=js"
export * from "./AttachmentStorage.vue?vue&type=script&lang=js"
import style0 from "./AttachmentStorage.vue?vue&type=style&index=0&id=21dc3818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dc3818",
  null
  
)

export default component.exports